import { Injectable, signal } from '@angular/core';

/** Shape of global search UI state (replaces former NgRx search feature slice). */
export interface ISearchState {
  searchStr: string;
  filterBy: string;
}

const initialSearchState: ISearchState = {
  searchStr: '',
  filterBy: '',
};

@Injectable({ providedIn: 'root' })
export class SearchStateService {
  private readonly _searchStr = signal<string>(initialSearchState.searchStr);
  private readonly _filterBy = signal<string>(initialSearchState.filterBy);

  readonly searchStr = this._searchStr.asReadonly();
  readonly filterBy = this._filterBy.asReadonly();

  maintainSearchInput(searchStr: string): void {
    this._searchStr.set(searchStr);
  }

  maintainFilterType(filterBy: string): void {
    this._filterBy.set(filterBy);
  }

  reset(): void {
    this._searchStr.set('');
    this._filterBy.set('');
  }
}
